import {gql} from 'apollo-angular';
export const GET_GAME_SCORE_BOARD = gql`
query GetGameScoreBoard($gameId: Int!) {
  getGameScoreBoard(gameID: $gameId) {
    multiplier
    entries {
      level
      points
      isHighScore
      reachedCount
    }
  }
}
`;
